import { Service } from "typedi";
import { TRON_FULL_NODES, TRON_SOLIDITY_NODES } from "../constants/config";

function createTronHostSelectorService() {
  return new TronHostSelectorService(
    TRON_FULL_NODES.split(","),
    TRON_SOLIDITY_NODES.split(",")
  );
}

@Service({ factory: createTronHostSelectorService })
export class TronHostSelectorService {
  private fullNodes: string[];
  private index: number;
  private solidityNodes: string[];

  constructor(fullNodes: string[], solidityNodes: string[]) {
    this.fullNodes = fullNodes;
    this.index = 0;
    this.solidityNodes = solidityNodes;
  }

  getNextFullNode() {
    const host = this.fullNodes[this.index];
    this.index = this.index === this.fullNodes.length - 1 ? 0 : ++this.index;
    return host;
  }

  getSolidityNode() {
    return this.solidityNodes[0];
  }
}
